import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_static/privacy-policy')({
	component: PrivacyPage,
});

function PrivacyPage() {
	const { t } = useTranslation();
	return <h1>{t('staticPages.privacyPolicy.title')}</h1>;
}
